module.exports = __webpack_public_path__ + "fonts/menu-1_svgrepo.com.svg";